import PropTypes from 'prop-types';
import React from 'react';
import CrumbName from './CrumbName';
import LinkedCrumb from './LinkedCrumb';
import './Breadcrumbs.less';

/* istanbul ignore next */
function handleCrumbNameClick(onClickCrumbName, crumb) {
    return (event) => onClickCrumbName(event, crumb);
}

function Breadcrumbs({
    ariaLabel,
    crumbs,
    isLastCrumbLinked,
    onClickCrumbName,
    ...rest
}) {
    const hasCrumbs = crumbs.length > 0;
    const lastCrumb = crumbs[crumbs.length - 1];
    return (
        <nav aria-label={ariaLabel} {...rest}>
            {hasCrumbs && (
                <ol
                    id="breadcrumb"
                    className="Breadcrumb text-muted"
                    vocab="https://schema.org/"
                    typeof="BreadcrumbList"
                >
                    {crumbs
                        .filter(
                            (crumb) => isLastCrumbLinked || crumb !== lastCrumb
                        )
                        .map((crumb, index) => (
                            <LinkedCrumb
                                key={index}
                                hasDivider={index !== crumbs.length - 1}
                                currentPage={index === crumbs.length - 1}
                                onClickName={handleCrumbNameClick(
                                    onClickCrumbName,
                                    crumb
                                )}
                                url={crumb.url}
                                name={crumb.name}
                                node={crumb.node}
                                position={index + 1}
                            />
                        ))}
                    {!isLastCrumbLinked && (
                        <li
                            className="Breadcrumb__li Breadcrumb__li--active"
                            property="itemListElement"
                            typeof="ListItem"
                        >
                            <CrumbName
                                name={lastCrumb.name}
                                positionContent={crumbs.length}
                            />
                        </li>
                    )}
                </ol>
            )}
        </nav>
    );
}

Breadcrumbs.propTypes = {
    /** aria-label for breadcrumb. A useful descriptor like "You are here:" */
    ariaLabel: PropTypes.string.isRequired,
    /** Array of urls, text to display in breadcrumb. Use the node property to pass in a Link component from react-router. */
    crumbs: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            node: PropTypes.node
        })
    ),
    /** If true, the last crumb will act like the other crumbs, with navigation behavior to specified url. */
    isLastCrumbLinked: PropTypes.bool,
    /** Event handler triggered whenever a linked crumb is clicked. Passes the event and the targeted crumb data */
    onClickCrumbName: PropTypes.func
};

Breadcrumbs.defaultProps = {
    ariaLabel: 'You are here:',
    crumbs: [],
    isLastCrumbLinked: false,
    onClickCrumbName: /* istanbul ignore next */ () => {}
};

export default Breadcrumbs;
